// extracted by mini-css-extract-plugin
export default {"about":"about_about__LoTcB","content":"about_content__TNJg4","para":"about_para__a+hzs"};